import { Label, TextArea } from '@iwoca/orion';
import { Trans, useLingui } from '@lingui/react/macro';
import { useFormContext } from 'react-hook-form';

import styles from './PurposeDetailsScreen.module.css';
import { purposeDetailsSchema } from './PurposeDetailsScreen.schema';
import { TMobileSignupForm } from '../../form/form';
import { useStageFieldTracking } from '../../form/MobileSignupFieldTracking';
import { useScreenValidation } from '../../form/validation/useScreenValidation';
import { StepLayout } from '../../StepLayout/StepLayout';

export const PurposeDetailsScreen = () => {
  const { t } = useLingui();
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext<TMobileSignupForm>();
  const { validateAndContinue } = useScreenValidation(purposeDetailsSchema);
  const { fieldProps } = useStageFieldTracking();

  const isRequired = watch('loanPurpose') === 'other';

  return (
    <StepLayout
      stageTitle={t`Credit request`}
      heading={t`What do you want to use the loan for?`}
      onContinue={validateAndContinue}
      fieldProps={fieldProps}
    >
      <Label htmlFor="loanPurposeDetails" className={styles.label}>
        <Trans>Additional Information</Trans>
        {!isRequired && (
          <span className={styles.optional}>
            {' '}
            (<Trans>optional</Trans>)
          </span>
        )}
      </Label>
      <TextArea
        {...register('loanPurposeDetails')}
        id="loanPurposeDetails"
        rows={4}
        className={styles.detail}
        placeholder={t`Please enter a purpose`}
        error={errors.loanPurposeDetails?.message}
      />
    </StepLayout>
  );
};
